module.exports = __webpack_public_path__ + "static/img/5.bacc7b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/5.jpg
// module id = 5PM7
// module chunks = 1